export default __webpack_public_path__ + "static/media/logo-pink.4260208b.svg";